import React from 'react'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string | undefined
    height?: string | number
    width?: string | number
    containerStyle?: React.CSSProperties
}
const Image: React.FC<ImageProps> = ({
    src,
    height,
    width,
    containerStyle,
    ...props
}: ImageProps) => {
    return (
        <div style={containerStyle}>
            <img
                src={src}
                height={height ?? '24px'}
                width={width ?? '24px'}
                {...props}
            />
        </div>
    )
}

export default Image
